module.exports = __webpack_public_path__ + "static/img/defaultimg.000462a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultimg.png
// module id = tzCM
// module chunks = 1